import Tag from './Tag'
export * from './Tag'
export default Tag
